module.exports = __webpack_public_path__ + "img/construccion.c6b43a6f.jpg";